import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams, Navigate } from 'react-router-dom';

import { Panel } from '@bigcommerce/big-design';
import ToolPage from '../partials/ToolPage';
import LoadingSpinner from '../partials/LoadingSpinner';

import { verifySession } from '../../redux/actions/payments';

const Session = ({ payload, payments, verifyCheckoutSession }) => {
  let { checkoutSessionId } = useParams();

  useEffect(() => {
    if (payments.verificationStatus !== 'success' && !payments.isFetching) {
      verifyCheckoutSession(payload, checkoutSessionId);
    }
  }, []);

  if (payments.verificationStatus === 'success') {
    return (
      <Navigate to="/" />
    )
  }

  return (
    <>
      <ToolPage title="Verifying Payment">
        <Panel>
          { payments.verificationStatus !== 'success' &&
            <LoadingSpinner size="large" statusText="Verifying Payment" />
          }
        </Panel>
      </ToolPage>
    </>
  )
}

const mapStateToProps = state => ({
  payments: state.payments,
});

const mapDispatchToProps = (dispatch) => ({
  verifyCheckoutSession: (payload, checkoutSessionId) => dispatch(verifySession(payload, checkoutSessionId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Session);
